// Template251: Bélgica - Día 3 Gante (Page9.jsx)
// Hero portada + título Gante + sticker, intro, Graslei/Korenlei, Campanario, Catedral San Bavón, caja transporte.

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";

const Template251 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;
	const intro = page?.texts?.[1]?.content;
	const block1Title = page?.texts?.[2]?.content;
	const block1Body = page?.texts?.[3]?.content;
	const block2Title = page?.texts?.[4]?.content;
	const block2Body = page?.texts?.[5]?.content;
	const block3Title = page?.texts?.[6]?.content;
	const block3Body = page?.texts?.[7]?.content;
	const transporteHtml = page?.texts?.[8]?.content;
	const transporteItems = page?.data?.transporte;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const portadaImage = getImageSrc("portada");
	const portadaSticker = getImageSrc("portada-sticker");
	const img1 = getImageSrc("img1");
	const img2 = getImageSrc("img2");
	const img3 = getImageSrc("img3");
	const logoImage = getCanvasImageUrl("logo");

	const sabiasQue = Array.isArray(page?.data?.sabiasQue)
		? page.data.sabiasQue
		: [];
	const actualHeaderColor = headerBackgroundColor || "#D4A017";

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: "14px",
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
	};

	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: "#444",
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
				{logoImage && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: isSmallScreen ? 66 : 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			<Box data-block-id="image-0" sx={{ position: "relative" }}>
				{portadaImage && (
					<Box
						component="img"
						src={portadaImage}
						alt=""
						sx={{ width: "100%", height: 200, objectFit: "cover" }}
					/>
				)}
				<Box
					component="h1"
					sx={{
						fontSize: isSmallScreen ? 28 : 32,
						textAlign: "center",
						position: "absolute",
						bottom: 0,
						margin: "10px",
						left: 20,
						color: "#fff",
						textShadow: "2px 2px 4px rgba(0,0,0,0.6)",
						fontWeight: 700,
					}}
				>
					Gante
				</Box>
				{portadaSticker && (
					<Box
						component="img"
						src={portadaSticker}
						alt=""
						sx={{ width: 100, position: "absolute", bottom: 60, left: 20 }}
					/>
				)}
			</Box>

			<Box
				data-block-id="text-1"
				sx={{
					padding: "10px 12px",
					paddingBottom: "5px",
					position: "relative",
				}}
			>
				{intro && (
					<Box
						component="p"
						sx={{
							fontSize: 13,
							color: "#333",
							margin: 0,
							padding: 0,
							marginTop: "-7px",
						}}
					>
						{intro}
					</Box>
				)}

				<Box
					data-block-id="text-2"
					sx={{
						display: "flex",
						flexDirection: "column",
						gap: 1.3,
						marginTop: "10px",
					}}
				>
					{/* Graslei y Korenlei */}
					{(block1Title || block1Body) && (
						<Box data-block-id="text-3" sx={{ display: "flex", gap: 2, position: "relative" }}>
							{sabiasQue[0] && (
								<Box sx={{ position: "absolute", top: 0, left: "33%" }}>
									<SabiasQue
										icono={sabiasQue[0].icono}
										texto={sabiasQue[0].texto}
									/>
								</Box>
							)}
							{img1 && (
								<Box
									component="img"
									src={img1}
									alt=""
									sx={{
										width: "40%",
										height: 110,
										objectFit: "cover",
										borderRadius: "12px",
									}}
								/>
							)}
							{sabiasQue[1] && (
								<Box sx={{ position: "absolute", top: 60, left: "33%" }}>
									<SabiasQue
										icono={sabiasQue[1].icono}
										texto={sabiasQue[1].texto}
									/>
								</Box>
							)}
							<Box sx={{ width: "60%", position: "relative" }}>
								{block1Title && (
									<Box component="h3" sx={estiloH3}>
										{block1Title}
									</Box>
								)}
								{block1Body && (
									<Box component="p" sx={{ ...estiloP, fontSize: 13 }}>
										{block1Body}
									</Box>
								)}
							</Box>
						</Box>
					)}

					{/* Campanario */}
					{(block2Title || block2Body) && (
						<Box data-block-id="text-4" sx={{ display: "flex", gap: 2, position: "relative" }}>
							{img2 && (
								<Box
									component="img"
									src={img2}
									alt=""
									sx={{
										width: "40%",
										height: 110,
										objectFit: "cover",
										borderRadius: "12px",
									}}
								/>
							)}
							{sabiasQue[2] && (
								<Box sx={{ position: "absolute", top: 30, left: "33%" }}>
									<SabiasQue
										icono={sabiasQue[2].icono}
										texto={sabiasQue[2].texto}
									/>
								</Box>
							)}
							<Box sx={{ width: "60%" }}>
								{block2Title && (
									<Box component="h3" sx={estiloH3}>
										{block2Title}
									</Box>
								)}
								{block2Body && (
									<Box component="p" sx={estiloP}>
										{block2Body}
									</Box>
								)}
							</Box>
						</Box>
					)}

					{/* Catedral San Bavón */}
					{(block3Title || block3Body) && (
						<Box data-block-id="text-5" sx={{ display: "flex", gap: 2, position: "relative" }}>
							{img3 && (
								<Box
									component="img"
									src={img3}
									alt=""
									sx={{
										width: "40%",
										height: 110,
										objectFit: "cover",
										borderRadius: "12px",
									}}
								/>
							)}
							{sabiasQue[3] && (
								<Box sx={{ position: "absolute", top: -10, left: "33%" }}>
									<SabiasQue
										icono={sabiasQue[3].icono}
										texto={sabiasQue[3].texto}
									/>
								</Box>
							)}
							<Box sx={{ width: "60%" }}>
								{block3Title && (
									<Box component="h3" sx={estiloH3}>
										{block3Title}
									</Box>
								)}
								{block3Body && (
									<Box component="p" sx={estiloP}>
										{block3Body}
									</Box>
								)}
							</Box>
						</Box>
					)}

					{/* Caja transporte */}
					{(transporteHtml ||
						(Array.isArray(transporteItems) && transporteItems.length > 0)) && (
						<Box
							data-block-id="text-6"
							sx={{
								backgroundColor: "#f9ebc8",
								border: "2px solid #D4A017",
								borderRadius: "12px",
								padding: "8px 16px",
								fontSize: "13px",
								color: "#444",
								marginTop: "-4px",
								textAlign: "center",
								marginBottom: isSmallScreen ? "10px" : 0,
							}}
						>
							{transporteHtml ? (
								<Box
									component="ul"
									sx={{
										...estiloP,
										listStyle: "disc",
										paddingLeft: 2,
										margin: 0,
										textAlign: "left",
										fontSize: "12px",
									}}
									dangerouslySetInnerHTML={{ __html: transporteHtml }}
								/>
							) : Array.isArray(transporteItems) &&
							  transporteItems.length > 0 ? (
								<Box
									component="ul"
									sx={{
										...estiloP,
										listStyle: "disc",
										paddingLeft: 18,
										margin: 0,
										textAlign: "left",
										fontSize: "12px",
									}}
								>
									{transporteItems.map((item, i) => (
										<Box component="li" key={i}>
											{item}
										</Box>
									))}
								</Box>
							) : null}
						</Box>
					)}
				</Box>
			</Box>
		</Box>
	);
};

Template251.thumbnail = "/images/template-1.png";
export default Template251;
